import { TermsModal } from "../components/Modal";
import VotingCard from "../components/VotingCard";
import styled from "styled-components";
import { useVoting } from "../hooks/useVoting";
import { useParams } from "react-router-dom";
import { useEffect, useCallback } from "react";

const Wrapper = styled.div`
    padding: 20px;
`

const resolveAlmacenCountry = (almacenInfo) =>
    almacenInfo?.country ||
    almacenInfo?.pais ||
    almacenInfo?.brandCountry ||
    almacenInfo?.restoCountry ||
    almacenInfo?.resto?.country ||
    almacenInfo?.resto?.pais ||
    almacenInfo?.restaurant?.country ||
    almacenInfo?.restaurant?.pais ||
    almacenInfo?.restoInfo?.country ||
    almacenInfo?.restoInfo?.pais ||
    ""

const VotingPage = (props) => {
    const { id } = useParams();
    const { getDataAlmacen, customQuestions, almacenInfo, almacenPoints, loader, pageThanks, onLike, onSelection, error } = useVoting();
    const almacenCountry = resolveAlmacenCountry(almacenInfo);

    useEffect(() => {
        if (id) {
            getDataAlmacen(id);
        }
    }, [id, getDataAlmacen]);

    const handleLike = useCallback(() => {
        onLike(id);
    }, [id, onLike]);

    const handleAccept = useCallback((data) => {
        // Función para aceptar términos - implementar si es necesario

    }, []);

    const setOpenModalTerms = useCallback(() => {
        // Función para abrir/cerrar modal de términos - implementar si es necesario

    }, []);

    const handleSelection = useCallback((data) => {
        onSelection(data);
    }, [onSelection]);

    return (
        <Wrapper>
            <VotingCard
                name={almacenInfo?.restoName || almacenInfo?.name || ""}
                avatar={almacenInfo?.brand || almacenInfo?.cover || almacenInfo?.avatar || ""}
                onLike={handleLike}
                thanks={pageThanks}
                resto={almacenInfo?.userName || ""}
                restoAddress={almacenInfo?.address || ""}
                category={almacenPoints?.level || ""}
                loading={loader}
                errorPage={!!error}
                errorMessage={error}
                onSelection={handleSelection}
                country={almacenCountry}
                almacenInfo={almacenInfo}
                customQuestions={customQuestions}
            />

            <TermsModal
                isOpen={false}
                onClose={() => setOpenModalTerms(false)}
                onAccept={handleAccept}
            />
        </Wrapper>
    )
}

export default VotingPage;
